import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogIn = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 200,
	height: 200,
	fill: "none",
	viewBox: "0 0 200 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M63.33 169.6H51.09a1.46 1.46 0 0 1-1.47-1.46v-22.43a1.46 1.46 0 0 1 1.47-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.46 1.46 0 0 1-1.46 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M86.08 169.6H73.84a1.47 1.47 0 0 1-1.46-1.46v-22.43a1.46 1.46 0 0 1 1.46-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.46 1.46 0 0 1-1.46 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M108.84 169.6H96.6a1.46 1.46 0 0 1-1.46-1.46v-22.43a1.46 1.46 0 0 1 1.46-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.47 1.47 0 0 1-1.46 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M131.6 169.6h-12.24a1.5 1.5 0 0 1-1.36-.9 2 2 0 0 1-.1-.56v-22.43a1.46 1.46 0 0 1 1.46-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.46 1.46 0 0 1-1.46 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M154.35 169.6h-12.23a1.46 1.46 0 0 1-1.47-1.46v-22.43a1.46 1.46 0 0 1 1.47-1.47h12.23a1.46 1.46 0 0 1 1.47 1.47v22.43a1.46 1.46 0 0 1-1.47 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M102.58 83.73a2.42 2.42 0 1 0 0-4.84 2.42 2.42 0 0 0 0 4.84"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue, #90AFE7)",
			d: "M176.1 133.91q0-.24-.19-.4a.6.6 0 0 0-.41-.16h-4.77a.6.6 0 0 0-.4.18.6.6 0 0 0-.16.4v9.47q.02.24.19.4t.42.16h4.76a.57.57 0 0 0 .56-.59z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-orange, #FF8164)",
			d: "M41.46 58.59a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-orange, #FF8164)",
			d: "M147.07 121.93H60.72a2.8 2.8 0 0 0-2.78 2.78v5.34a2.8 2.8 0 0 0 .93 2.08l8.32-4.75-1.62 5.46h81.5a2.8 2.8 0 0 0 2.79-2.8v-5.32a2.8 2.8 0 0 0-2.79-2.8"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint0_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M181.95 67.51a2.01 2.01 0 1 0 0-4.03 2.01 2.01 0 0 0 0 4.03"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint1_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M74.29 19.44v11.91"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint2_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M80.24 25.4h-11.9"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint3_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M173.11 103.34v-50a6.53 6.53 0 0 0-6.53-6.53h-128a6.53 6.53 0 0 0-6.52 6.52v92.02a6.53 6.53 0 0 0 6.53 6.53h1.86"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint4_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M173.11 125.45v-18.56"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint5_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M173.11 65.5H32.06"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "var(--illu-warning-accent-blue-dark, #6A89C1)",
			fillRule: "evenodd",
			d: "M166.92 53.68c0-3.71-7.2-4.68-7.2-4.68v9.36c1.6-.21 7.2-.97 7.2-4.68M156 60.72c0-1.59 2.1-2.15 3.72-2.36V63s-3.72-.46-3.72-2.28",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint6_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M41.46 58.59a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint7_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M48.75 58.59a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint8_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M56.06 58.59a2.41 2.41 0 1 0 0-4.83 2.41 2.41 0 0 0 0 4.83"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint9_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M102.58 83.73a2.42 2.42 0 1 0 0-4.84 2.42 2.42 0 0 0 0 4.84"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint10_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M95.45 92.6s1.8-5.78 7.12-5.7 7.14 5.7 7.14 5.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint11_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M102.58 99.1a13.35 13.35 0 1 0 0-26.7 13.35 13.35 0 0 0 0 26.7"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint12_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M147.88 114.46H59.92a2 2 0 0 1-2-2v-6.93a2 2 0 0 1 2-2h87.96a2 2 0 0 1 1.99 2v6.94a2 2 0 0 1-2 1.98"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint13_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M64.21 110.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint14_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M70.1 110.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint15_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M75.99 110.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint16_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M81.87 110.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint17_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M87.76 110.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint18_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M93.64 110.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint19_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M99.53 110.7a1.7 1.7 0 1 0 0-3.4 1.7 1.7 0 0 0 0 3.4"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint20_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M58.87 132.13a2.8 2.8 0 0 1-.94-2.08v-5.33a2.8 2.8 0 0 1 2.8-2.79h86.34a2.8 2.8 0 0 1 2.78 2.79v5.33a2.8 2.8 0 0 1-2.78 2.79h-81.5"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint21_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m64.21 137.4 2.98-10.02-17.54 10.01h-3.44a5.75 5.75 0 0 0-5.75 5.76v26.48a5.75 5.75 0 0 0 5.75 5.76h112.75a5.76 5.76 0 0 0 5.75-5.75v-26.5a5.75 5.75 0 0 0-5.75-5.75z"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint22_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M63.33 169.6H51.09a1.46 1.46 0 0 1-1.47-1.46v-22.43a1.46 1.46 0 0 1 1.47-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.46 1.46 0 0 1-1.46 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint23_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M52.8 165.94h8.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint24_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M86.08 169.6H73.84a1.47 1.47 0 0 1-1.46-1.46v-22.43a1.46 1.46 0 0 1 1.46-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.46 1.46 0 0 1-1.46 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint25_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M75.56 165.94h8.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint26_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M108.84 169.6H96.6a1.46 1.46 0 0 1-1.46-1.46v-22.43a1.46 1.46 0 0 1 1.46-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.5 1.5 0 0 1-.9 1.35q-.27.1-.56.11"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint27_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M98.31 165.94h8.82"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint28_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M131.6 169.6h-12.24a1.5 1.5 0 0 1-1.36-.9 2 2 0 0 1-.1-.56v-22.43a1.46 1.46 0 0 1 1.46-1.47h12.24a1.46 1.46 0 0 1 1.46 1.47v22.43a1.46 1.46 0 0 1-1.46 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint29_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M121.07 165.94h8.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint30_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M154.35 169.6h-12.23a1.46 1.46 0 0 1-1.47-1.46v-22.43a1.46 1.46 0 0 1 1.47-1.47h12.23a1.46 1.46 0 0 1 1.47 1.47v22.43a1.46 1.46 0 0 1-1.47 1.46"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint31_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M143.83 165.94h8.81"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint32_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M156.56 137.4v-11.88h33.06v13.61a16.49 16.49 0 0 1-24.9 14.3"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint33_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M189.62 125.52v-5.8a16.5 16.5 0 0 0-16.66-16.38 16.24 16.24 0 0 0-16.4 16.52v5.66"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint34_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M185.96 125.38v-5.77a12.8 12.8 0 0 0-12.94-12.72 12.63 12.63 0 0 0-12.76 12.83v5.78"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint35_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M175.54 143.96h-4.76a.6.6 0 0 1-.42-.16.6.6 0 0 1-.19-.4v-9.46a.6.6 0 0 1 .16-.42.6.6 0 0 1 .4-.18h4.77a.6.6 0 0 1 .6.57v9.46a.6.6 0 0 1-.16.41.6.6 0 0 1-.4.18"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint36_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M192.95 169.83q-.15 0-.3-.1a.5.5 0 0 1-.18-.23q-.08-.23-.18-.44a.5.5 0 0 1 .1-.57 1.6 1.6 0 0 0 0-2.24l-.75-.76a1.56 1.56 0 0 0-2.23 0 .5.5 0 0 1-.57.1l-.44-.18a.5.5 0 0 1-.33-.48 1.6 1.6 0 0 0-.97-1.46q-.3-.12-.6-.12h-1.08a1.6 1.6 0 0 0-1.46.97q-.12.3-.11.61a.5.5 0 0 1-.33.48l-.44.18a.5.5 0 0 1-.57-.1 1.56 1.56 0 0 0-2.23 0l-.76.76a1.6 1.6 0 0 0 0 2.24.5.5 0 0 1 .11.57l-.18.44q-.06.15-.19.24a.5.5 0 0 1-.29.09 1.6 1.6 0 0 0-1.57 1.58v1.08a1.6 1.6 0 0 0 1.57 1.59q.15 0 .3.09.12.09.18.24l.18.43a.5.5 0 0 1-.1.57 1.6 1.6 0 0 0 0 2.24l.75.77a1.56 1.56 0 0 0 2.23 0 .5.5 0 0 1 .57-.1l.44.17a.5.5 0 0 1 .33.48 1.6 1.6 0 0 0 .97 1.47q.3.11.6.12h1.08a1.6 1.6 0 0 0 1.46-.98q.1-.3.11-.6a.5.5 0 0 1 .33-.49q.23-.08.44-.18a.5.5 0 0 1 .57.1 1.56 1.56 0 0 0 2.23 0l.76-.76a1.6 1.6 0 0 0 0-2.24.5.5 0 0 1-.11-.57q.1-.21.18-.44.06-.15.19-.24a.5.5 0 0 1 .29-.09 1.6 1.6 0 0 0 1.58-1.58v-1.08a1.6 1.6 0 0 0-1.58-1.58"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint37_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "M185.96 175.98a4.02 4.02 0 1 0-.02-8.04 4.02 4.02 0 0 0 .02 8.04"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint38_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m15.56 108.04-4.19 4.21 4.2 4.12-4.19 4.2 4.22 4.32-4.2 4.2 4.32 4.31"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "url(#log-in_svg__paint39_linear_4001_8136)",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			d: "m9.67 115.64-4.2 4.2 4.21 4.13-4.19 4.2 4.21 4.31-4.2 4.21L9.83 141"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint0_linear_4001_8136",
				x1: 181.385,
				x2: 182.788,
				y1: 66.202,
				y2: 64.963,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint1_linear_4001_8136",
				x1: 74.646,
				x2: 75.263,
				y1: 27.478,
				y2: 27.433,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint2_linear_4001_8136",
				x1: 72.629,
				x2: 72.695,
				y1: 26.072,
				y2: 25.376,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint3_linear_4001_8136",
				x1: 82.969,
				x2: 119.3,
				y1: 117.702,
				y2: 74.62,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint4_linear_4001_8136",
				x1: 173.471,
				x2: 174.089,
				y1: 119.412,
				y2: 119.383,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint5_linear_4001_8136",
				x1: 82.969,
				x2: 82.975,
				y1: 66.173,
				y2: 65.472,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint6_linear_4001_8136",
				x1: 40.792,
				x2: 42.472,
				y1: 57.017,
				y2: 55.534,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint7_linear_4001_8136",
				x1: 48.082,
				x2: 49.761,
				y1: 57.017,
				y2: 55.534,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint8_linear_4001_8136",
				x1: 55.391,
				x2: 57.07,
				y1: 57.017,
				y2: 55.534,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint9_linear_4001_8136",
				x1: 101.91,
				x2: 103.595,
				y1: 82.156,
				y2: 80.667,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint10_linear_4001_8136",
				x1: 100.601,
				x2: 102.105,
				y1: 90.747,
				y2: 87.426,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint11_linear_4001_8136",
				x1: 98.869,
				x2: 108.166,
				y1: 90.414,
				y2: 82.202,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint12_linear_4001_8136",
				x1: 91.111,
				x2: 92.123,
				y1: 110.903,
				y2: 103.378,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint13_linear_4001_8136",
				x1: 63.742,
				x2: 64.925,
				y1: 109.593,
				y2: 108.547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint14_linear_4001_8136",
				x1: 69.626,
				x2: 70.809,
				y1: 109.593,
				y2: 108.547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint15_linear_4001_8136",
				x1: 75.513,
				x2: 76.696,
				y1: 109.593,
				y2: 108.547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint16_linear_4001_8136",
				x1: 81.399,
				x2: 82.582,
				y1: 109.593,
				y2: 108.547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint17_linear_4001_8136",
				x1: 87.284,
				x2: 88.467,
				y1: 109.593,
				y2: 108.547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint18_linear_4001_8136",
				x1: 93.168,
				x2: 94.351,
				y1: 109.593,
				y2: 108.547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint19_linear_4001_8136",
				x1: 99.054,
				x2: 100.237,
				y1: 109.593,
				y2: 108.547,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint20_linear_4001_8136",
				x1: 91.112,
				x2: 92.122,
				y1: 129.289,
				y2: 121.773,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint21_linear_4001_8136",
				x1: 85.308,
				x2: 97.672,
				y1: 159.772,
				y2: 131.501,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint22_linear_4001_8136",
				x1: 55.097,
				x2: 62.444,
				y1: 161.354,
				y2: 157.475,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint23_linear_4001_8136",
				x1: 55.978,
				x2: 56.067,
				y1: 166.617,
				y2: 165.926,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint24_linear_4001_8136",
				x1: 77.853,
				x2: 85.201,
				y1: 161.354,
				y2: 157.473,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint25_linear_4001_8136",
				x1: 78.737,
				x2: 78.826,
				y1: 166.617,
				y2: 165.926,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint26_linear_4001_8136",
				x1: 100.613,
				x2: 107.96,
				y1: 161.354,
				y2: 157.474,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint27_linear_4001_8136",
				x1: 101.493,
				x2: 101.581,
				y1: 166.617,
				y2: 165.926,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint28_linear_4001_8136",
				x1: 123.369,
				x2: 130.717,
				y1: 161.354,
				y2: 157.473,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint29_linear_4001_8136",
				x1: 124.251,
				x2: 124.34,
				y1: 166.617,
				y2: 165.926,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint30_linear_4001_8136",
				x1: 146.127,
				x2: 153.475,
				y1: 161.354,
				y2: 157.474,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint31_linear_4001_8136",
				x1: 147.009,
				x2: 147.097,
				y1: 166.617,
				y2: 165.926,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint32_linear_4001_8136",
				x1: 168.492,
				x2: 179.09,
				y1: 145.913,
				y2: 135.675,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint33_linear_4001_8136",
				x1: 168.49,
				x2: 175.985,
				y1: 118.303,
				y2: 108.434,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint34_linear_4001_8136",
				x1: 169.535,
				x2: 175.936,
				y1: 119.444,
				y2: 111.635,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint35_linear_4001_8136",
				x1: 172.313,
				x2: 175.268,
				y1: 140.51,
				y2: 139.053,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint36_linear_4001_8136",
				x1: 183.578,
				x2: 189.566,
				y1: 174.959,
				y2: 169.694,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint37_linear_4001_8136",
				x1: 184.843,
				x2: 187.649,
				y1: 173.361,
				y2: 170.894,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint38_linear_4001_8136",
				x1: 12.941,
				x2: 15.579,
				y1: 125.156,
				y2: 124.756,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "log-in_svg__paint39_linear_4001_8136",
				x1: 7.047,
				x2: 9.684,
				y1: 132.751,
				y2: 132.351,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "var(--illu-warning-grad-from, #6A89C1)" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "var(--illu-warning-grad-to, #D9401C)"
				})]
			})
		] })
	]
});
export default SvgLogIn;
